<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="position-relative grid-content" style="margin-top: 10px;">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()" (keydown.enter)="openAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (keydown.enter)="openAuditTrail('overAll',0)" (click)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table class="dynamic-table-container" style="max-height: 60vh;">
      <thead>
        <th style="min-width: 60px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>

        <th id="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
            <span>Review Period Name</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Review Period Name',trainingReviewPeriod)" 
              (keydown.enter)="sortColumn('Review Period Name',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('reviewPeriodName', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
            <span>Review Period Description</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Review Period Description',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Review Period Description',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('reviewPeriodDescription', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
            <span>Is Fixed Period?</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Is Default With Score Template?',trainingReviewPeriod)" (keydown.enter)="sortColumn('Is Default With Score Template?',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('isFixedPeriod', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>From Date</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Is Default Without Score Template?',trainingReviewPeriod)" (keydown.enter)="sortColumn('Is Default Without Score Template?',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('fromDate', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>To Date</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Is Default Without Score Template?',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Is Default Without Score Template?',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('toDate', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Is Active?</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Is Default Without Score Template?',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Is Default Without Score Template?',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('isActive', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Created On</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Created On',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Created On',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('createdOn', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Created By</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Created By',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Created By',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('createdByUser', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Updated On</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Updated On',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Updated On',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('updatedOn', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Updated By</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Updated By',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Updated By',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('updatedByUser', $event,'string')" />
          </div>
        </th>

           <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Update Reason</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Update Reason',trainingReviewPeriod)"
              (keydown.enter)="sortColumn('Update Reason',trainingReviewPeriod)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('updateReason', $event,'string')" />
          </div>
        </th>

        <th id="menu" class="sticky-col first-col"></th>
      </thead>
      <tbody>
        <tr *ngFor="let list of pagedItems let idx = index;" [class.highlightRow]="list.childCheckBox == true">
          <td style="min-width: 60px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>

          <td  class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.reviewPeriodName}}
          </td>

          <td  class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.reviewPeriodDescription}}
          </td>

          <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'100px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <span>
              <div class="gridCheckBoxes">
                <img *ngIf="list.isFixedPeriod == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20" height="20"
                  alt="Yes">
                <img *ngIf="list.isFixedPeriod != 'Y'" src="../../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" alt="No">
              </div>
            </span>
          </td>

          <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.fromDate | date:'dd-MMM-yyyy'}}
          </td>

          <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.toDate | date:'dd-MMM-yyyy'}}
          </td>

          <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'100px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <span>
              <div class="gridCheckBoxes">
                <img *ngIf="list.isActive == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20" height="20"
                  alt="Yes">
                <img *ngIf="list.isActive != 'Y'" src="../../../assets/img/noAcessSymbol.svg" width="20" height="20"
                  alt="No">
              </div>
            </span>
          </td>

          <td id="grid-row-container" class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}
          </td>
          <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.createdByUser}}
          </td>
          <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.updatedOn | date:'dd-MMM-yyyy HH:mm:ss'}}
          </td>
          <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.updatedByUser}}
          </td>
           <td class="sticky-dynamic-row1 grid-row-container"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.updateReason}}
          </td>

          <td class="sticky-col first-col">
            <div class="action-icons">
              <i class="fa-solid fa-pencil" matTooltip="Edit" style="margin-left: 5px;"
                (click)="openEditPopup(list)" (keydown.enter)="openEditPopup(list)"></i>
              <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete" style="margin-left: 5px;"
                (click)="openDeletePopup(list)" (keydown.enter)="openDeletePopup(list)"></i>
              <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('individual',list)" (keydown.enter)="openAuditTrail('individual',list)" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }} 1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddOrEdit()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row" style="overflow:hidden">
        <div class="col-md-4">
          <div>
            <label id="review-period-name" for="email">Review Period Name</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <input id="reviewPeriodName" class="input-filed-continers" type="text"
            [(ngModel)]="trainingReviewPeriod.reviewPeriodName"
            (ngModelChange)="onNgModelChange($event,'review-period-name')">
        </div>
        <div class="col-md-4">
          <div>
            <label id="review-period-description" for="email">Review Period Description</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <input id="reviewPeriodDescription" class="input-filed-continers" type="text"
            [(ngModel)]="trainingReviewPeriod.reviewPeriodDescription"
            (ngModelChange)="onNgModelChange($event,'review-period-description')">
        </div>
        <div class="col-md-4">
          <div><label for="email">From Date</label></div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="trainingReviewPeriod.fromDate"
            (ngModelChange)="onFromDateChange()">
        </div>
        <div class="col-md-4">
          <div><label for="email">To Date</label></div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$generateToDateConfig()"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="trainingReviewPeriod.toDate"
            [disabled]="!trainingReviewPeriod.fromDate">
        </div>
        <div class="col-md-4">
          <div><label for="email">Is Fixed Period</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingReviewPeriod.isFixedPeriod"
            (change)="isActive($event.checked)">
            <span class="active-inActive-container" *ngIf="trainingReviewPeriod.isFixedPeriod==true"
              [ngStyle]="trainingReviewPeriod.isFixedPeriod == true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="trainingReviewPeriod.isFixedPeriod==false"
              [ngStyle]="trainingReviewPeriod.isFixedPeriod == false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-4">
          <div><label for="email">Status</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingReviewPeriod.isActive"
            (change)="isActive($event.checked)">
            <span class="active-inActive-container" *ngIf="trainingReviewPeriod.isActive==true"
              [ngStyle]="trainingReviewPeriod.isActive == true?{'color':'green'} : {'color': ''}">Active</span>
            <span *ngIf="trainingReviewPeriod.isActive==false"
              [ngStyle]="trainingReviewPeriod.isActive == false?{'color':'red'} : {'color': ''}">InActive</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-4" *ngIf="visibleEditButton">
          <div><label for="email" id="update-validation">Update Reason</label> <span class="mandatory-symbol">*</span></div>
          <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px;"
          rows="4" cols="50" [(ngModel)]="trainingReviewPeriod.updateReason"></textarea>
      </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addOrEdit(trainingReviewPeriod)" (keydown.enter)="addOrEdit(trainingReviewPeriod)" *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addOrEdit(trainingReviewPeriod)" (keydown.enter)="addOrEdit(trainingReviewPeriod)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddOrEdit()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDelete()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="trainingReviewPeriod.deleteReason"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="deleteCall(trainingReviewPeriod)" (keydown.enter)="deleteCall(trainingReviewPeriod)">
        <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Delete</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelDelete()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>